import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useStyles } from './AccountsIndexPage.style'
import { Button, TextField } from '@material-ui/core'
import { Add, ExpandMore, ExpandLess } from '@material-ui/icons'
import { loadPage } from '~/state/modules/accounts'
import { ExpandedRowMacro } from './ExandedRowMacro'
import { ExpandedRowProducers } from './ExandedRowProducers'
import { ExpandedRowBankTransfer } from './ExpandedRowBankTransfer'
import { ExpandedRowMp } from './ExpandedRowMp/ExpandedRowMp'
import moment from 'moment'
import {
  TableGrid,
  createColumn,
  createCustomColumn,
  TableGridOrder
} from '~/views/shared'
import history from '~/config/history'
import { ROUTES } from '~/views/routes'

const makeColumns = (
  classes,
  expandedPlataforma,
  setExpandedPlataforma,
  setExpandedProductoras,
  setIsMacro,
  setIsMp,
  setIsTransfer,
  setSelected
) => {
  return [
    createColumn('Id', 'Id'),
    createColumn('Cuit', 'CUIT'),
    createColumn('RazonSocial', 'Razón Social'),
    createCustomColumn(
      (c) => (
        <Button
          onClick={() => {
            setSelected(c)
            setExpandedProductoras(null)
            if (c.Platform === 'MacroClick') {
              setIsMp(false)
              setIsTransfer(false)
              setIsMacro(true)
            }
            if (c.Platform === 'MercadoPago') {
              setIsMacro(false)
              setIsTransfer(false)
              setIsMp(true)
            }
            if (c.Platform === 'BankTransfer') {
              setIsMacro(false)
              setIsMp(false)
              setIsTransfer(true)
            }
            expandedPlataforma === c.Id
              ? setExpandedPlataforma(null)
              : setExpandedPlataforma(c.Id)
          }}
          endIcon={
            expandedPlataforma === c.Id ? <ExpandLess /> : <ExpandMore />
          }
          className={classes.button}>
          {c.Platform}
        </Button>
      ),
      'Productoras Asociadas'
    )
  ]
}
const makeFooterActions = () => [
  {
    title: 'Crear Cuenta Macro',
    icon: <Add />,
    action: () => {
      history.push(ROUTES.ADMIN.ACCOUNTS.CREATE_MACRO)
    }
  },
  {
    title: 'Vincular cuenta (Transferencia)',
    icon: <Add />,
    action: () => {
      history.push(ROUTES.ADMIN.ACCOUNTS.CREATE_TRANSFER)
    }
  }
]

export const AccountsIndexPage = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { pagedList, pending, reqParams } = useSelector(
    (state) => state.accounts
  )
  const [expandedProductoras, setExpandedProductoras] = useState(null)
  const [expandedPlataforma, setExpandedPlataforma] = useState(null)
  const [isMacro, setIsMacro] = useState(false)
  const [isMp, setIsMp] = useState(false)
  const [isTransfer, setIsTransfer] = useState(false)
  const [selected, setSelected] = useState()
  const [search, setSearch] = useState(reqParams?.searchParams || '')

  const handleSearchKeyPress = (event) => {
    if (event.key === 'Enter') {
      performSearch()
    }
  }

  const performSearch = () => {
    dispatch(
      loadPage({
        searchParams: search,
        pageNumber: 0,
        pageSize: 10,
        orderBy: reqParams?.orderBy || 'Id',
        order: reqParams?.order || TableGridOrder.DESC
      })
    )
  }

  const getRowClasses = (item) => {
    const isAfter = moment().isAfter(item?.ExpirationDate)
    const isSameOrAfter6Days = moment()
      .add(6, 'days')
      .isSameOrAfter(item?.ExpirationDate)

    if (item.Platform === 'MercadoPago') {
      if (isAfter) {
        return classes.inactiveRow
      } else if (isSameOrAfter6Days) {
        return classes.warningRow
      }
    }
    return ''
  }

  const makeSearchForm = () => {
    return (
      <div className={classes.form}>
        <TextField
          fullWidth
          className={classes.input}
          placeholder='Filtrar por Nombre'
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onKeyPress={handleSearchKeyPress}
        />
        <Button variant='contained' color='primary' onClick={performSearch}>
          Buscar
        </Button>
      </div>
    )
  }

  return (
    <TableGrid
      title='Listado de Pasarelas de Pagos'
      rowClasses={(x) => getRowClasses(x)}
      columns={makeColumns(
        classes,
        expandedPlataforma,
        setExpandedPlataforma,
        setExpandedProductoras,
        setIsMacro,
        setIsMp,
        setIsTransfer,
        setSelected
      )}
      footerActions={makeFooterActions()}
      searchForm={makeSearchForm}
      searchParams={search}
      loadItemsPage={(x) => {
        dispatch(
          loadPage({
            searchParams: search,
            pageNumber: x.pageNumber || reqParams?.pageNumber,
            pageSize: x.pageSize,
            orderBy: x.orderBy,
            order: x.order
          })
        )
      }}
      isLoading={pending}
      pagedList={pagedList}
      keyName='Id'
      pageSize={reqParams?.pageSize || 10}
      order={reqParams?.order || TableGridOrder.DESC}
      orderBy={reqParams?.orderBy || 'Id'}
      useNewFormat
      expandedRow={expandedPlataforma || expandedProductoras}
      ExpandedRowComponent={
        <div className={classes.expandedRow}>
          {isMacro && <ExpandedRowMacro macroData={selected} />}
          {isMp && <ExpandedRowMp mpData={selected} />}
          {isTransfer && <ExpandedRowBankTransfer transferData={selected} />}
          <ExpandedRowProducers organizers={selected?.Organizers} />
        </div>
      }
    />
  )
}

export default AccountsIndexPage
